
import CodeMirror from 'codemirror'
import Parser from './../Core/Parser/Parser'

(function (CodeMirror) {
    CodeMirror.registerHelper('lint', 'psflex', function (text, options, cm) {
        let found = []

        function errorCb (msg, lineFrom, columnFrom, lineTo, columnTo) {
            found.push({from: CodeMirror.Pos(lineFrom, columnFrom), to: CodeMirror.Pos(lineTo, columnTo), message: msg})
        }

        let parser = new Parser({
            errorCb: errorCb,
            procNameCb: function (name) {
                CodeMirror.signal(cm, 'processNameChange', {
                    name: name
                })
            },
            config: window.LangConfig
        })
        try {
            parser.lint(text)
        } catch (e) {
            console.log(e)
        }

        return found
    })
})(CodeMirror)



// WEBPACK FOOTER //
// ./src/Codemirror/lint.js